import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'PENDING_APMS',
    itemActionName: 'PENDING_APM',
});
